import { motion, AnimatePresence } from "framer-motion";
import { useState, Children } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import {Flex, Box, Text, Button} from '@radix-ui/themes';


const Carousel = ({ 
    children, 
    currentIndex: externalIndex, 
    onIndexChange,
    autoAdvance = false,
    disableControls = false,
    containerStyle = {}
}) => {
    // Use local or external state based on props
    const [internalIndex, setInternalIndex] = useState(0);
    const currentIndex = externalIndex ?? internalIndex;
    
    const [direction, setDirection] = useState(0);

    // Convert children to array
    const items = Children.toArray(children);

    const slideVariants = {
        // enter: (direction) => ({
        //     x: direction > 0 ? 1000 : -1000,
        //     opacity: 0
        // }),
        // center: {
        //     zIndex: 1,
        //     x: 0,
        //     opacity: 1
        // },
        // exit: (direction) => ({
        //     zIndex: 0,
        //     x: direction < 0 ? 1000 : -1000,
        //     opacity: 0
        // })
        enter: (direction) => ({
            y:  500,
            opacity: 0
        }),
        center: {
            zIndex: 1,
            y: 0,
            opacity: 1
        },
        exit: (direction) => ({
            zIndex: 0,
            y: 500,
            opacity: 0
        })
    };

    const paginate = (newDirection) => {
        const newIndex = currentIndex + newDirection;
        if (newIndex >= 0 && newIndex < items.length) {
            setDirection(newDirection);
            // Use external control if provided, otherwise use internal
            if (onIndexChange) {
                onIndexChange(newIndex);
            } else {
                setInternalIndex(newIndex);
            }
        }
    };

    // Allow direct index setting from parent
    const goToIndex = (index) => {
        if (index >= 0 && index < items.length) {
            const direction = index > currentIndex ? 1 : -1;
            setDirection(direction);
            if (onIndexChange) {
                onIndexChange(index);
            } else {
                setInternalIndex(index);
            }
        }
    };

    return (
        <Flex justify="center" align="center" width="100%" style={{position:'relative', minHeight:'450px', overflow:'hidden', ...containerStyle}}>
            <AnimatePresence initial={false} custom={direction}>
                <motion.div
                    key={currentIndex}
                    custom={direction}
                    variants={slideVariants}
                    initial="enter"
                    animate="center"
                    exit="exit"
                    transition={{
                        x: { type: "spring", stiffness: 300, damping: 30 },
                        opacity: { duration: 0.2 }
                    }}
                    className="flex items-center justify-center"
                    style={{position:'absolute', width:'100%', height:'100%'}}
                >
                    {items[currentIndex]}
                </motion.div>
            </AnimatePresence>

            {!disableControls && items.length > 1 && (
                <>
                    <button
                        className="absolute left-4 z-10 p-2 rounded-full bg-white/30 hover:bg-white/50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        onClick={() => paginate(-1)}
                        disabled={currentIndex === 0}
                    >
                        <FaChevronLeft />
                    </button>
                    <button
                        className="absolute right-4 z-10 p-2 rounded-full bg-white/30 hover:bg-white/50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        onClick={() => paginate(1)}
                        disabled={currentIndex === items.length - 1}
                    >
                        <FaChevronRight />
                    </button>
                </>
            )}
        </Flex>
    );
};

export default Carousel;
